export class MaximumActivePromotionsExceededException {}